import { render } from "./auto-copy.vue?vue&type=template&id=65d00c4b&ts=true"
import script from "./auto-copy.vue?vue&type=script&lang=ts"
export * from "./auto-copy.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__